import { DictionaryProduct, ExtractProduct, LoadingStatusEnum, DictionaryProductSchema, ExtractProductSchema, } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "../../slice/etlData.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

type LoadProductsResponse = {
	extractProducts: ExtractProduct[];
	dictionaryProducts: DictionaryProduct[];
	productsMappingArray: ItemMapping[];
};

export const loadProducts = createAppAsyncThunk<LoadProductsResponse, void>(
	"etlData/loadProducts",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [dictionaryProducts, extractProducts] = await Promise.all([
				extra.etlClient.findAll(DictionaryProductSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractProductSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				extractProducts,
				dictionaryProducts,
				productsMappingArray: []
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (_, { getState }) => {
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.productsLoadingStatus);
		}
	}
);
